/**
 * Spinner — accessible loading indicator. role=status + NL aria-label so
 * screen readers announce "Bezig met laden..." while data fetches.
 */
import { cn } from './cn';

export interface SpinnerProps {
  /** Pixel size of the spinner; defaults to 16. */
  size?: number;
  /** Override the default NL aria-label. */
  label?: string;
  className?: string;
}

export function Spinner({
  size = 16,
  label = 'Bezig met laden...',
  className,
}: SpinnerProps): JSX.Element {
  return (
    <span
      role="status"
      aria-label={label}
      aria-live="polite"
      className={cn('inline-flex items-center justify-center', className)}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className="animate-spin text-fg-muted motion-reduce:animate-none"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}
